import cloneDeep from 'lodash/cloneDeep';
import { useRef } from 'react';
export const usePreviousDeep = (value) => {
    const prevRef = useRef(value);
    const prevHolder = prevRef.current;
    prevRef.current = cloneDeep(value);
    if (!prevHolder)
        return value;
    return prevHolder;
};
